import gql from 'graphql-tag';

export const query = gql`
  query GameJoinability(
    $gameType: GameType!
    $gameId: Int!
    $timeZone: String!
    $isAuthenticated: Boolean!
  ) {
    game(type: $gameType, id: $gameId) {
      id
      joinability(timeZone: $timeZone) {
        joinable
        code
      }
      ... on FalkorGame {
        # Only requested when authenticated - userStatusV2's resolver
        # resolves the caller off the JWT and 500s for an anonymous one
        # with no userId argument (wb-graphql-service's
        # FalkorGame.userStatusV2 does userId || jwtData.sub).
        userStatusV2 @include(if: $isAuthenticated) {
          isPlayer
        }
      }
    }
  }
`;
